import { ThemeConfig } from './types';

export const h12: ThemeConfig = {
    tenant: 'h12',
    baseColor: '#1F9AE8',
    navColor: '#ffffff',
    textColor: '#444',
    hoverColor: '#133880',
    disabled: '#999999',
    inputBgColor: "#FBFBFC",
    matrixHoverColor: '#133880',
    matrixHoverTextColor: '#444',
    matrixOddBgColor: '#FBFBFC',
    matrixOddTextColor: '#444'
};

export default h12;

/*
@kleur_blauw: #1F9AE8;
@kleur_donkerblauw: #133880;
@kleur_lichtgrijs: #b3b3b3;
@kleur_donkergrijs: #444444;
*/